import React, { useRef, useEffect, useState } from "react";

const CircularThumbnail = ({
  imageUrl,
  cropData,
  size = 200,
  alt = "Thumbnail",
  className = "",
}) => {
  const canvasRef = useRef(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!imageUrl || !cropData || !canvasRef.current) return;
    
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    // Set canvas dimensions
    canvas.width = size;
    canvas.height = size;

    // Create circular clipping path
    ctx.beginPath();
    ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
    ctx.closePath();
    ctx.clip();

    const img = new Image();
    img.crossOrigin = "anonymous";

    img.onload = () => {
      try {
        // Calculate source coordinates based on crop data
        const imgWidth = img.naturalWidth;
        const imgHeight = img.naturalHeight;

        // Use x1,y1,x2,y2 format exclusively
        const x1 = (cropData.x1 / 100) * imgWidth;
        const y1 = (cropData.y1 / 100) * imgHeight;
        const x2 = (cropData.x2 / 100) * imgWidth;
        const y2 = (cropData.y2 / 100) * imgHeight;

        // The source rectangle
        const sourceX = x1;
        const sourceY = y1;
        const sourceWidth = x2 - x1;
        const sourceHeight = y2 - y1;

        // Use the smaller dimension to ensure we get a square
        const sourceDiameter = Math.min(sourceWidth, sourceHeight);

        // Ensure we don't go out of bounds
        const safeSourceX = Math.max(0, sourceX);
        const safeSourceY = Math.max(0, sourceY);
        const safeDiameter = Math.min(
          sourceDiameter,
          imgWidth - safeSourceX,
          imgHeight - safeSourceY
        );

        // Draw the cropped portion
        ctx.drawImage(
          img,
          safeSourceX,     // Source X
          safeSourceY,     // Source Y
          safeDiameter,    // Source width
          safeDiameter,    // Source height
          0,               // Destination X
          0,               // Destination Y
          size,            // Destination width
          size             // Destination height
        );
      } catch (err) {
        console.error("Error drawing thumbnail:", err);
        setError(true);
      }
    };

    img.onerror = (err) => {
      console.error("Failed to load image for thumbnail:", err, imageUrl);
      setError(true);
    };

    img.src = imageUrl;
  }, [imageUrl, cropData, size]);

  if (error) {
    return (
      <div
        className={`rounded-full bg-gray-700 overflow-hidden ${className}`}
        style={{ width: size, height: size }}
      >
        <img
          src="/default-avatar.png"
          alt={alt}
          className="w-full h-full object-cover"
        />
      </div>
    );
  }

  return (
    <canvas
      ref={canvasRef}
      className={`rounded-full ${className}`}
      style={{ width: size, height: size }}
      alt={alt}
    />
  );
};

export default CircularThumbnail;
